import { render, staticRenderFns } from "./giftsetsalert-grid.vue?vue&type=template&id=6719d3cd"
import script from "./giftsetsalert-grid.vue?vue&type=script&lang=js"
export * from "./giftsetsalert-grid.vue?vue&type=script&lang=js"
import style0 from "./giftsetsalert-grid.vue?vue&type=style&index=0&id=6719d3cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports